import React from "react";
import ReactDOM from "react-dom";
import "./css/modal.css";
import "./css/index.css";
import "./css/colors.css";
import "./css/buttons.css";
import "./css/ionic.css";
import "./css/forms.css";
import App from "./App";
import moment from "moment";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";

moment.locale("es", {
  monthsShort: "Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic".split("_"),
});

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
